import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
// import {
//   ReduxAsyncConnect,
//   asyncConnect,
//   reducer as reduxAsyncConnect,
// } from 'redux-async-connect';
import { reducer as formReducer } from 'redux-form';
import * as reducers from './index';

import { getActionIds } from '../helpers/redux';
import { AppActions } from '../actions/app';
const appActions = getActionIds(AppActions);

const rootReducer = combineReducers({
  // reduxAsyncConnect,
  routing: routerReducer,
  ...reducers,
  form: formReducer,
});

export const createRootReducer = apolloClient => {
  const appReducer = combineReducers({
    // reduxAsyncConnect,
    routing: routerReducer,
    ...reducers,
    form: formReducer,
    // apollo: apolloClient.reducer(),
  });

  const rootReducer = (state, action) => {
    return appReducer(
      action.type === appActions.globalResetReducers ? { ...appReducer({}, action), routing: (state && state.routing) || {}  } : state,
      action,
    );
  }

  return rootReducer;
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/root.js